"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = __importDefault(require("autobind-decorator"));
const store_1 = __importDefault(require("../../../redux/store"));
const chatSlice_1 = require("../../../redux/slices/chatSlice");
class Socket {
    init() {
        this.socket = window.AppearMe.Widgets.Socket;
        this.socket.subscribe('newMessage', this.newMessage);
        this.socket.subscribe('messageDeleted', this.deleteMessage);
    }
    deregister() {
        this.socket.unsubscribe('newMessage');
        this.socket.unsubscribe('messageDeleted');
    }
    newMessage(data) {
        return store_1.default.dispatch(chatSlice_1.setMessage(data));
    }
    deleteMessage(data) {
        console.log('deleted', data);
        return store_1.default.dispatch(chatSlice_1.removeMessage(data));
    }
}
__decorate([
    autobind_decorator_1.default
], Socket.prototype, "newMessage", null);
__decorate([
    autobind_decorator_1.default
], Socket.prototype, "deleteMessage", null);
exports.default = Socket;
